import { createShapeNormalizer } from '@change-corgi/fcm/normalizers';

import { defineFcm } from '../shared/factory';

export const FCM_PAYMENT_FLOW_TRAFFIC_CONTROL = defineFcm('payment_flow_traffic_control')
	.asJson(
		createShapeNormalizer({
			type: 'object',
			shape: {
				experimentName: { type: 'string' },
			},
		}),
	)
	.withDefault({
		experimentName: '',
	})
	.toConfig();
